export default function SeatAllocation() {
  return (
    <>
      <section className="section section-alt">
        <div className="container">
          <p className="section-eyebrow">Two ways to travel</p>
          <h2 className="section-title">Travel your way</h2>
          <p className="section-sub">
            Whether you're travelling solo or with the whole family, RouteRider
            fits your trip.
          </p>
          <div className="compare-grid">
            <div className="compare-card reveal in">
              <span className="compare-badge">Most popular</span>
              <h3>🧑‍🤝‍🧑 Per-Seat Sharing</h3>
              <p className="price">
                From ₹249 <span>/ seat</span>
              </p>
              <ul className="check-list">
                <li>Share the cab with fellow riders on the same route</li>
                <li>Pay only for the seat(s) you book</li>
                <li>Great for solo &amp; budget travellers</li>
                <li>Verified co-riders, rated &amp; reviewed</li>
              </ul>
              <button className="btn btn-primary btn-block" data-scroll="#hero">
                Book a seat
              </button>
            </div>
            <div className="compare-card reveal in">
              <h3>🚙 Full Cab</h3>
              <p className="price">
                From ₹1,499 <span>/ trip</span>
              </p>
              <ul className="check-list">
                <li>The entire cab is reserved just for you</li>
                <li>Ideal for families, groups &amp; luggage</li>
                <li>Flexible pickup time, no sharing</li>
                <li>Choose sedan, SUV or hatchback</li>
              </ul>
              <button className="btn btn-outline btn-block" data-scroll="#hero">
                Book full cab
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
